import modelBaseV2 from "../model-base-v2.model";
import codeMasterModel from "../common/code-master.model";
import { codeMasterType } from "../../config/constants";

const GscmDivisionModel = {

    getGscmDivisionHierarchy: function () {
        return modelBaseV2.get('/api/codemaster/prodHir');
    },

    getGscmDivisions: function () {
        return codeMasterModel.getByCategoryV2({ category: codeMasterType.gscmDivSap });
    },

    getGscmDivisionsForNewModelDisplayFlooring: function (week = '') {
        let options = {};
        if (week) {
            options.params = { week: week };
        }

        return modelBaseV2.get(`/api/model/gscmdivision/newmodeldisplayflooring`, options);
    }

}

export default GscmDivisionModel;